import { BannerProps, BannerIconProps, ExpandableProps } from '@procore/core-react/dist/_typedoc/Banner/Banner.types.json';
import * as React from 'react';
export default {
  BannerProps,
  BannerIconProps,
  ExpandableProps,
  React
};